import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';


const routes: CustomRoute = {
	path: '/our-mission',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'ourMission' */ './component')],
			render: ([OurMission]) => <OurMission />,
			onEnter: async ({ next }) => {
				console.log('on Enter ourMission');
				await next();
				console.log('on Enter ourMission / end');
			},
		},
	],
};

export default routes;
